"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var querystring_parser_1 = require("@aws-sdk/querystring-parser");

var url_1 = require("url");

exports.parseUrl = function (url) {
  var _url_1$parse = url_1.parse(url),
      _url_1$parse$hostname = _url_1$parse.hostname,
      hostname = _url_1$parse$hostname === void 0 ? "localhost" : _url_1$parse$hostname,
      _url_1$parse$pathname = _url_1$parse.pathname,
      pathname = _url_1$parse$pathname === void 0 ? "/" : _url_1$parse$pathname,
      port = _url_1$parse.port,
      _url_1$parse$protocol = _url_1$parse.protocol,
      protocol = _url_1$parse$protocol === void 0 ? "https:" : _url_1$parse$protocol,
      search = _url_1$parse.search;

  var query;

  if (search) {
    query = querystring_parser_1.parseQueryString(search);
  }

  return {
    hostname: hostname,
    port: port ? parseInt(port) : undefined,
    protocol: protocol,
    path: pathname,
    query: query
  };
};